
import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/style/page-turning.ejs';


class StylePageTurningView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;

        this.model.set(propName, propVal);
    }

    render() {
        super.render();
        this.$el.html(this.template(this.model.toJSON()));

        this.updateAttributes();
        this.delegateEvents();
        return this;
    }


}

export default StylePageTurningView;
